import { render, staticRenderFns } from "./TbFilaDetail.vue?vue&type=template&id=4b1942ef&scoped=true"
import script from "./TbFilaDetail.vue?vue&type=script&lang=js"
export * from "./TbFilaDetail.vue?vue&type=script&lang=js"
import style0 from "./TbFilaDetail.vue?vue&type=style&index=0&id=4b1942ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1942ef",
  null
  
)

export default component.exports